import React from 'react';
import './CloseButton.css'; // Add custom styles

const CloseButton = ({ onClick }) => (
  <div className='close-icon'>
    <img onClick={onClick} src="/assets/close-popup.png" alt="Close" />
  </div>
);

export default CloseButton;
